export default "assets/images/logo-interloire-dcca63d4.png";